import Queue from '@sravni/utils/lib/queue';

export const queue = new Queue({ debug: false });
